import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class SalaryRuleDTO  {
    _originalTypeClassName = "zERP.BO.SalaryRuleDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
SalaryRuleDTO.translate = translateService;
}
this.Id = null;
this.Name = null;
this.AADEId = null;
this.AADECode = null;
this.AADECodeName = null;
this.APDId = null;
this.APDCode = null;
this.APDCodeName = null;
this.SalaryRuleDTOKey = null;
this._key = this.SalaryRuleDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Id:any;
Name:any;
AADEId:any;
AADECode:any;
AADECodeName:any;
APDId:any;
APDCode:any;
APDCodeName:any;
private _SalaryRuleDTOKey:any;
get SalaryRuleDTOKey(): any {
    return this._SalaryRuleDTOKey;
  }
set SalaryRuleDTOKey(value: any) {
    this._SalaryRuleDTOKey = value;
    this._key = value;
  }

static Assign(sr: any): any{let srDTO = new Domain.SalaryRuleDTO();
srDTO.Id = sr?.Id;
srDTO.Name = sr?.Name;
srDTO.AADEId = sr?.AADECode?.Id;
srDTO.AADECode = sr?.AADECode?.Code;
srDTO.AADECodeName = sr?.AADECode?.CodeAndName;
srDTO.APDId = sr?.APDCode?.Id;
srDTO.APDCode = sr?.APDCode?.Code;
srDTO.APDCodeName = sr?.APDCode?.CodeAndName;
return srDTO;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.SalaryRuleDTOKey == null || $this.SalaryRuleDTOKey == 0;
            }


}